module.exports = __webpack_public_path__ + "img/php.af906185.svg";